<div data-aos="flip-left"
     data-aos-easing="ease-out-cubic"
     data-aos-duration="2000" id="contact" class="container">
  <div class="row justify-content-center">
    <h1 class="mt-3 text-center text-white">Contact</h1>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-md-6 col-12 mt-2">
      <mat-card>
        <a class="text-center" href="https://api.whatsapp.com/send?phone=+212639564084">
          <i class="fa fa-phone fa-1x"></i> +212639564084
        </a>
      </mat-card>
    </div>
    <div class="col-md-6 col-12 mt-2">
      <mat-card>

        <a class="text-center" href="mailto:yassinabidar201@gmail.com">
          <i class="fas fa-envelope-open"></i> yassinabidar201@gmail.com
        </a>
      </mat-card>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-md-12">
      <mat-card class="example-card mt-2">
        <mat-card-content>
          <form #f="ngForm">
            <div class="form-group">
              <label>Votre Email Adresse</label>
              <input email required ngModel #email="ngModel" (change)="log(email)" name="email" matInput
                     placeholder="pat@example.com" class="form-control" required>
              <div *ngIf="email.invalid && email.touched">
                <mat-error *ngIf="email.errors?.required">Email Adresse est obligatoire !!</mat-error>
              </div>
            </div>
            <br>
            <div class="form-group">
              <label>Sujet</label>
              <input required ngModel #sujet="ngModel" name="sujet" class="form-control" matInput placeholder="Sujet">
              <div *ngIf="sujet.invalid && sujet.touched">
                <mat-error *ngIf="sujet.errors?.required">C'est quoi le sujet?</mat-error>
              </div>
            </div>
            <div class="form-group">
              <label>Sujet</label>
              <textarea class="form-control" required ngModel #message="ngModel" name="message" matInput
                        placeholder="message"></textarea>
              <div *ngIf="message.invalid && message.touched">
                <mat-error *ngIf="message.errors?.required">C'est quoi votre message?</mat-error>
              </div>
            </div>
            <br>
          </form>
        </mat-card-content>
        <button (click)="submitForm(f)" [disabled]="f.invalid" type="button" mdbBtn color="primary" mdbWavesEffect>Send
          <i
            class="fas fa-paper-plane"></i></button>
      </mat-card>
    </div>

  </div>
</div>
